// extracted by mini-css-extract-plugin
export default {"tooltip":"JHXU+","tooltipContent":"_1nq7a","active":"u6cjp"};